export const baseUrl = "https://main.cmc16batch.in";
// export const baseUrl = "http://localhost:8000";

export const config = {
  headers: {
    'Access-Control-Allow-Origin': '*',
  }
};



